import { useEffect, useState } from "react";
import { IoAddOutline } from "react-icons/io5";

const emptyForm = {
  name: "",
  slug: "",
  description: "",
  isPublished: true,
  sortOrder: 1,
};

export default function PageFormModal({
  open,
  initial,
  busy,
  onClose,
  onSubmit,
}) {
  const [form, setForm] = useState(emptyForm);
  const isEdit = Boolean(initial?.id);

  useEffect(() => {
    if (!open) return;
    if (initial) {
      setForm({
        name: initial.name || "",
        slug: initial.slug || "",
        description: initial.description || "",
        isPublished: initial.isPublished !== false,
        sortOrder: initial.sortOrder ?? 1,
      });
    } else {
      setForm(emptyForm);
    }
  }, [open, initial]);

  if (!open) return null;

  function handleChange(e) {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    onSubmit({
      ...form,
      slug: form.slug.trim().toLowerCase(),
      sortOrder: Number(form.sortOrder) || 0,
    });
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <button
        type="button"
        aria-label="Close"
        className="absolute inset-0 bg-slate-900/40"
        onClick={onClose}
      />
      <form
        onSubmit={handleSubmit}
        className="relative w-full max-w-lg rounded-2xl border border-gray-200 bg-white p-6 shadow-xl"
      >
        <h2 className="text-lg font-semibold text-slate-900">
          {isEdit ? "Edit page" : "Create page"}
        </h2>

        <div className="mt-5 space-y-4">
          <label className="block text-sm">
            <span className="font-medium text-slate-700">Name</span>
            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              required
              className="mt-1 w-full rounded-xl border border-gray-200 px-3 py-2 outline-none focus:border-slate-400 focus:ring-2 focus:ring-slate-200"
            />
          </label>

          <label className="block text-sm">
            <span className="font-medium text-slate-700">Slug</span>
            <input
              name="slug"
              value={form.slug}
              onChange={handleChange}
              required
              className="mt-1 w-full rounded-xl border border-gray-200 px-3 py-2 outline-none focus:border-slate-400 focus:ring-2 focus:ring-slate-200"
            />
          </label>

          <label className="block text-sm">
            <span className="font-medium text-slate-700">Description</span>
            <textarea
              name="description"
              value={form.description}
              onChange={handleChange}
              rows={3}
              className="mt-1 w-full rounded-xl border border-gray-200 px-3 py-2 outline-none focus:border-slate-400 focus:ring-2 focus:ring-slate-200"
            />
          </label>

          <div className="flex flex-wrap gap-6">
            <label className="flex items-center gap-2 text-sm text-slate-700">
              <input
                type="checkbox"
                name="isPublished"
                checked={form.isPublished}
                onChange={handleChange}
              />
              Published
            </label>

            <label className="block text-sm">
              <span className="font-medium text-slate-700">Sort order</span>
              <input
                type="number"
                name="sortOrder"
                value={form.sortOrder}
                onChange={handleChange}
                className="mt-1 w-24 rounded-xl border border-gray-200 px-3 py-2"
              />
            </label>
          </div>
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            disabled={busy}
            className="rounded-xl border border-gray-200 px-4 py-2 text-sm font-medium text-slate-700"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={busy}
            className="inline-flex items-center gap-2 rounded-xl bg-slate-900 px-4 py-2 text-sm font-medium text-white disabled:opacity-60"
          >
            <IoAddOutline className="h-4 w-4" />
            {busy ? "Saving…" : isEdit ? "Save changes" : "Create page"}
          </button>
        </div>
      </form>
    </div>
  );
}
